<template>
  <div :key="key" class="dashboard-chart">
    <h4>CO4</h4>
    <!-- :separator-step="parseInt(indicadorRSEPjeObjetivo)" -->
    <vue-svg-gauge
      :start-angle="-110"
      :end-angle="110"
      :value="indicadorRSEPjeActual"
      :separator-step= 0
      :min="indicadorRSEMin"
      :max="indicadorRSEMax"
      :gauge-color="indicadorRSEColor"
      :scale-interval="1"/>
    <div class="dashboard-chart-text">
      <p>Presupuestos: {{ indicadorRSEPresupuestosConfirmados }}</p>
      <p>Presupuestos CO4: {{ indicadorRSEPresupuestosConfirmadosRSE }}</p>
      <p>Pje Objetivo: {{ indicadorRSEPjeObjetivo | numero(2, true) }} %</p>
      <p>Pje Actual: {{ indicadorRSEPjeActual | numero(2, true) }} %</p>
      <p class="description">{{ indicadorRSEDescripcion }}</p>
    </div>
  </div>
</template>

<script>
import { VueSvgGauge } from 'vue-svg-gauge';

export default {
  components: {
    VueSvgGauge,
  },
  data() {
    return {
      rojo: '#E46651',
      verde: '#41B883',
      amarillo: '#FAFA05',
      rosa: '#FF0187',

      key: 0,
      indicadorRSEPjeObjetivo: 0,
      indicadorRSEPjeActual: 0,
      indicadorRSEColor: [{ offset: 0, color: '#41B883'}, { offset: 100, color: '#41B883' }],
      indicadorRSEMin: 0,
      indicadorRSEMax: 100,
      indicadorRSEPresupuestosConfirmados: 0,
      indicadorRSEPresupuestosConfirmadosRSE: 0,
      indicadorRSEDescripcion: '',
    }
  },
  methods: {
    getIndicador() {
      this.$store.dispatch('resultadosIndicadores/getIndicadorRSE')
        .then(() => {
          let indicador = this.$store.getters['resultadosIndicadores/indicadorRSE']

          this.indicadorRSEPresupuestosConfirmados = indicador.presupuestosConfirmados;
          this.indicadorRSEPresupuestosConfirmadosRSE = indicador.presupuestosConfirmadosRSE;
          this.indicadorRSEPjeObjetivo = parseFloat(indicador.pjeObjetivo);
          this.indicadorRSEPjeActual = parseFloat(indicador.pjeActual);
          this.indicadorRSEDescripcion = indicador.indicadorPeriodo? indicador.indicadorPeriodo.trim() : '';
          // this.indicadorRSEDescripcion = indicador.descripcion? indicador.descripcion.trim() : '';
        })
        .finally(() => this.key++);
    },
  }
}
</script>

<style>
</style>


